import { apiRequest } from '../request'

interface ValidateB2BTokenPayload {
  companySlug: string
  token: string
}

export interface ValidateB2BTokenResponse {
  isTokenVerified: boolean
  redirectUrl: string
  firstName: string
  lastName: string
  email: string
}

export async function validateB2BToken(payload: ValidateB2BTokenPayload) {
  return apiRequest<ValidateB2BTokenResponse | null>('/b2b/validate-partner-token', {
    method: 'POST',
    body: payload,
  })
}
